import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import ArticlePage from "@/pages/article/superbuy-spreadsheet-guide/page";
import SafetyArticlePage from "@/pages/article/superbuy-spreadsheet-safety/page";
import TipsArticlePage from "@/pages/article/superbuy-spreadsheet-tips/page";
import ComparisonArticlePage from "@/pages/article/superbuy-spreadsheet-comparison/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/article/superbuy-spreadsheet-guide",
    element: <ArticlePage />,
  },
  {
    path: "/article/superbuy-spreadsheet-safety",
    element: <SafetyArticlePage />,
  },
  {
    path: "/article/superbuy-spreadsheet-tips",
    element: <TipsArticlePage />,
  },
  {
    path: "/article/superbuy-spreadsheet-comparison",
    element: <ComparisonArticlePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;